// extracted by mini-css-extract-plugin
export default {"row":"EventOfferPerShow_row__9WOD+","wrapper":"EventOfferPerShow_wrapper__l0AY8","item":"EventOfferPerShow_item__V+V5I"};